import { Leaderboard } from "@datagame/ui";

import { Game } from "../../../../../../gql/graphql";
import { isLeaderboardGame } from "../../../../../../graphql/helpers/LeaderboardGame";
import { STEPS_TO_CONFIGURE_PROJECT } from "../GamePreview";
import { LEADERBOARD_TEST_RESULTS } from "../../../../../../constants";

import styles from "./TriviaPreview.module.scss";

export interface TriviaPreviewProps {
  game: Game;
  step?: STEPS_TO_CONFIGURE_PROJECT;
}

export const TriviaPreview = ({ game, step }: TriviaPreviewProps) => {
  if (
    isLeaderboardGame(game) &&
    game.configuration.showLeaderboard &&
    step === STEPS_TO_CONFIGURE_PROJECT.GAME_SETTINGS
  ) {
    const toShow = game.configuration.leaderboardConfiguration?.numberOfPlayers;
    return (
      <div className={styles.wrapper}>
        <Leaderboard
          configuration={game.configuration.leaderboardConfiguration}
          results={LEADERBOARD_TEST_RESULTS.slice(0, toShow)}
        />
      </div>
    );
  }
  return null;
};
